/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// date js
function convertToRoman(num) {
if (num === 0) return "N"; 
  if (num < 0 || num > 3999) return "Invalid number"; 

  const romanNumerals = [
    { value: 1000, symbol: "M" },
    { value: 900, symbol: "CM" },
    { value: 500, symbol: "D" },
    { value: 400, symbol: "CD" },
    { value: 100, symbol: "C" },
    { value: 90, symbol: "XC" },
    { value: 50, symbol: "L" },
    { value: 40, symbol: "XL" },
    { value: 10, symbol: "X" },
    { value: 9, symbol: "IX" },
    { value: 5, symbol: "V" },
    { value: 4, symbol: "IV" },
    { value: 1, symbol: "I" }
  ];

  let result = "";

  for (let i = 0; i < romanNumerals.length; i++) {
    while (num >= romanNumerals[i].value) {
      result += romanNumerals[i].symbol;
      num -= romanNumerals[i].value;
    }
  }

  return result;
}

const dateInput = document.getElementById("date-input");

dateInput?.addEventListener("change", function () {

  const inputDate = dateInput.value;


  const dateValue = new Date(inputDate);
  const day = dateValue.getDate();
  const month = dateValue.getMonth() + 1;
  const year = dateValue.getFullYear();

  const romanDay = convertToRoman(day);
  const romanMonth = convertToRoman(month);
  const romanYear = convertToRoman(year);
  
  $(".hidden-input-date").val(`${romanDay}.${romanMonth}.${romanYear}`);
  $("#Date-view").text(`${romanDay}.${romanMonth}.${romanYear}`);

});
